import React from 'react';
import Container from './components/Container';
import DeveloperInformation from './components/DeveloperInformation';
import FooterItems from './components/FooterItems';
import PaymentInfo from '../subscriptions/paymentInfo/PaymentInfo';

const Footer = () => {
  const showPaymentInfo = window.location.pathname === "/subscription-plans";

  return (
    <Container>
      {showPaymentInfo && <PaymentInfo />}
      <FooterItems />
      <DeveloperInformation />
    </Container>
  );
};

export default Footer;
